var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIntercomBubble({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2083 27.7502C26.2083 27.7502 23.613 26.7225 21.5132 25.8992H12.6843C11.6391 25.8992 10.7916 24.9951 10.7916 23.8799V12.0403C10.7916 10.9252 11.6391 10.021 12.6843 10.021H24.3151C25.3603 10.021 26.2077 10.9252 26.2077 12.0403V22.237H26.2083V27.7502ZM23.9296 21.1118C23.7476 20.8859 23.43 20.8598 23.2181 21.0533C23.2016 21.068 21.5578 22.539 18.4994 22.539C15.479 22.539 13.8099 21.0787 13.7801 21.0521C13.5683 20.8596 13.2515 20.8859 13.0698 21.1112C12.9825 21.2195 12.9392 21.3606 12.9494 21.5034C12.9597 21.6461 13.0226 21.7785 13.1243 21.8712C13.2025 21.9421 15.072 23.6163 18.4994 23.6163C21.9274 23.6163 23.7969 21.9421 23.8751 21.8712C23.9766 21.7785 24.0394 21.6462 24.0497 21.5037C24.0599 21.3611 24.0167 21.22 23.9296 21.1118Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntercomBubble);
export default __webpack_public_path__ + "static/media/intercom-bubble.d306833b1244b582156af02e94e289f0.svg";
export { ForwardRef as ReactComponent };